export default function HideColumn() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'>
      <mask
        id='mask0_7348_7528'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='16'
        height='16'
      >
        <rect width='16' height='16' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_7348_7528)'>
        <path
          d='M4.37948 13.0279L5.04615 10.3612H2.50781L2.75781 9.36123H5.29615L5.97565 6.64323H3.43731L3.68731 5.64323H6.22565L6.89231 2.97656H7.87948L7.21281 5.64323H9.96931L10.636 2.97656H11.6231L10.9565 5.64323H13.4948L13.2448 6.64323H10.7065L10.027 9.36123H12.5653L12.3153 10.3612H9.77698L9.11031 13.0279H8.12315L8.78981 10.3612H6.03331L5.36665 13.0279H4.37948ZM6.28331 9.36123H9.03981L9.71931 6.64323H6.96281L6.28331 9.36123Z'
          fill='#777777'
        />
      </g>
    </svg>
  );
}
